import {ItemCountView} from '../../../../shared/scripts/ui_canvas_engine/ItemCountView'
import {UIGamePlayerInformationLongestRoadView} from '../../../../shared/scripts/ui_game/ui_game_players/UIGamePlayerInformationLongestRoadView'

export class UIWGamePlayerInformationLongestRoadView extends UIGamePlayerInformationLongestRoadView {
    protected createMyDefaultLongestRoadView() {
        // design: https://www.figma.com/file/U2GMIvGeBKSuhEPWqrkLas/Player-Info-Final?node-id=0%3A1
        const playerInformationW = this.playerInformation.width
        const playerInformationH = this.playerInformation.height

        const longestRoadX = playerInformationW * 0.8369
        const longestRoadY = playerInformationH * 0.4833
        const longestRoadW = playerInformationW * 0.0915
        const longestRoadH = playerInformationH * 0.25

        const longestRoadCountX = playerInformationW * 0.82772
        const longestRoadCountY = playerInformationH * 0.77
        const longestRoadCountW = playerInformationW * 0.1098
        const longestRoadCountH = playerInformationH * 0.1

        const iconPadding = -playerInformationW * 0.015
        this.longestRoadView = new ItemCountView(longestRoadX, longestRoadY, longestRoadW, longestRoadH, this.playerInformation, this.longestRoadTexture,
            longestRoadCountX, longestRoadCountY, longestRoadCountW, longestRoadCountH, iconPadding)
    }

    protected createMyCitiesAndKnightsLongestRoadView() {
        // design: https://www.figma.com/file/U2GMIvGeBKSuhEPWqrkLas/Player-Info-Final?node-id=0%3A1
        const playerInformationW = this.playerInformation.width
        const playerInformationH = this.playerInformation.height

        const longestRoadX = playerInformationW * 0.809
        const longestRoadY = playerInformationH * 0.4267
        const longestRoadW = playerInformationW * 0.0804
        const longestRoadH = playerInformationH * 0.22

        const longestRoadCountX = playerInformationW * 0.8943
        const longestRoadCountY = longestRoadY
        const longestRoadCountW = playerInformationW * 0.1
        const longestRoadCountH = longestRoadH

        const iconPadding = -longestRoadW * 0.0786
        this.longestRoadView = new ItemCountView(longestRoadX, longestRoadY, longestRoadW, longestRoadH, this.playerInformation, this.longestRoadTexture,
            longestRoadCountX, longestRoadCountY, longestRoadCountW, longestRoadCountH, iconPadding)
        this.longestRoadView.resetTextYPosition()
    }

    protected createOpponentDefaultLongestRoadView() {
        // design: https://www.figma.com/file/U2GMIvGeBKSuhEPWqrkLas/Player-Info-Final?node-id=0%3A1
        const playerInformationW = this.playerInformation.width
        const playerInformationH = this.playerInformation.height

        const longestRoadX = playerInformationW * 0.8369
        const longestRoadY = playerInformationH * 0.2155
        const longestRoadW = playerInformationW * 0.0915
        const longestRoadH = playerInformationH * 0.3879

        const longestRoadCountX = playerInformationW * 0.82772
        const longestRoadCountY = playerInformationH * 0.64
        const longestRoadCountW = playerInformationW * 0.1098
        const longestRoadCountH = playerInformationH * 0.1

        const iconPadding = -playerInformationW * 0.015
        this.longestRoadView = new ItemCountView(longestRoadX, longestRoadY, longestRoadW, longestRoadH, this.playerInformation, this.longestRoadTexture,
            longestRoadCountX, longestRoadCountY, longestRoadCountW, longestRoadCountH, iconPadding)
    }

    protected createOpponentCitiesAndKnightsLongestRoadView() {
        // design: https://www.figma.com/file/U2GMIvGeBKSuhEPWqrkLas/Player-Info-Final?node-id=0%3A1
        const playerInformationW = this.playerInformation.width
        const playerInformationH = this.playerInformation.height

        const longestRoadX = playerInformationW * 0.809
        const longestRoadY = playerInformationH * 0.1045
        const longestRoadW = playerInformationW * 0.0804
        const longestRoadH = playerInformationH * 0.341

        const longestRoadCountX = playerInformationW * 0.8943
        const longestRoadCountY = longestRoadY
        const longestRoadCountW = playerInformationW * 0.1
        const longestRoadCountH = longestRoadH

        const iconPadding = -longestRoadW * 0.078
        this.longestRoadView = new ItemCountView(longestRoadX, longestRoadY, longestRoadW, longestRoadH, this.playerInformation, this.longestRoadTexture,
            longestRoadCountX, longestRoadCountY, longestRoadCountW, longestRoadCountH, iconPadding)
        this.longestRoadView.resetTextYPosition()
    }
}
